import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function BookInformationGuideOutlineIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M6 19H21V1H6C4.3457 1 3 2.3457 3 4V20C3 21.6543 4.3457 23 6 23H19V21H6C5.44824 21 5 20.5518 5 20C5 19.4482 5.44824 19 6 19ZM5 4C5 3.44824 5.44824 3 6 3H19V17H6C5.64941 17 5.3125 17.0606 5 17.1709V4ZM11 9.5H13V14H11V9.5ZM10.5 6.5C10.5 5.67163 11.1716 5 12 5C12.8284 5 13.5 5.67163 13.5 6.5C13.5 7.32837 12.8284 8 12 8C11.1716 8 10.5 7.32837 10.5 6.5Z",
    fill: "currentColor"
  }));
}